// App.js
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollReveal from './components/ScrollReveal';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Gallery from './pages/Gallery';
import CV from './pages/CV';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Exhibition from './pages/Exhibition';
import Commission from './pages/Commission';
import Testimonials from './pages/Testimonials';
import School from './pages/School';

function ScrollToTopOnNavigate() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, [pathname]);

  return null;
}

function App() {
  // Add scroll to top on route change
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);

  return (
    <BrowserRouter>
      <div className="app">
        <ScrollToTopOnNavigate />
        <ScrollReveal />
        <Navbar />
        <div className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/exhibition" element={<Exhibition />} />
            <Route path="/commission" element={<Commission />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/school" element={<School />} />
            <Route path="/cv" element={<CV />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
        <ScrollToTop />
      </div>
    </BrowserRouter>
  );
}

export default App;